import React from 'react';
import { Select, Space, Radio } from 'antd';

const { Option } = Select;

const TechnicalFilters = ({ filters, onChange, darkMode }) => {
  const segmentOptions = [
    { id: 0, name: '? (Bilinmiyor)', color: '#d4d4d4' },
    { id: 1, name: 'E Segment', color: '#ff0200' },
    { id: 2, name: 'D Segment', color: '#ff5600' },
    { id: 3, name: 'C Segment', color: '#ecd300' },
    { id: 4, name: 'B Segment', color: '#b5dc0a' },
    { id: 5, name: 'A Segment', color: '#69d406' },
    { id: 6, name: 'A+ Segment', color: '#27d60d' }
  ];

  const handleSegmentChange = (segmentId) => {
    onChange('segment', segmentId);
  };

  const renderSegmentOption = (segment) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div
        style={{
          width: 16,
          height: 16,
          borderRadius: '50%',
          backgroundColor: segment.color,
          marginRight: 8,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontSize: 10,
          fontWeight: 'bold'
        }}
      >
        {segment.id === 0 ? '?' : ['E', 'D', 'C', 'B', 'A', 'A+'][segment.id - 1]}
      </div>
      {segment.name}
    </div>
  );

  return (
    <Space direction="vertical" size="small" style={{ width: '100%' }}>
      <div>
        <label style={{
          display: 'block',
          marginBottom: 4,
          fontSize: 12,
          color: darkMode ? '#ccc' : '#666'
        }}>
          Segment Filtresi
        </label>
        <Select
          mode="multiple"  
          style={{ width: '100%' }}
          placeholder="Segment seçin"
          value={filters.segment || []}
          onChange={handleSegmentChange}
          allowClear
        >
          {segmentOptions.map(segment => (
            <Option key={segment.id} value={segment.id}>
              {renderSegmentOption(segment)}
            </Option>
          ))}
        </Select>

          {filters.segment?.length > 0 && (
            <div style={{
              fontSize: 10,
              color: darkMode ? '#999' : '#666',
              marginTop: 4,
              padding: '4px 8px',
              backgroundColor: darkMode ? '#2a2a2a' : '#f5f5f5',
              borderRadius: '4px'
            }}>
              <strong>Segment Açıklaması:</strong><br />
              {filters.segment.map(segmentId => {
                const descriptions = {
                  0: 'Segment bilgisi belirsiz olan lokasyonlar',
                  1: 'En düşük performans segmenti - Günlük işlem sayısı çok az',
                  2: 'Düşük performans segmenti - Günlük işlem sayısı az',
                  3: 'Orta performans segmenti - Günlük işlem sayısı orta',
                  4: 'İyi performans segmenti - Günlük işlem sayısı iyi',
                  5: 'Yüksek performans segmenti - Günlük işlem sayısı yüksek',
                  6: 'En yüksek performans segmenti - Günlük işlem sayısı çok yüksek'
                };
                return descriptions[segmentId];
              }).filter(Boolean).join(', ')}
            </div>
          )}
      </div>

      <div style={{ marginTop: '12px' }}>
        <label style={{
          display: 'block',
          marginBottom: 8,
          fontSize: 12,
          color: darkMode ? '#ccc' : '#666'
        }}>
          Segment Renk Kılavuzu
        </label>
        <div style={{ fontSize: 10 }}>
          {segmentOptions.map(segment => (
            <div key={segment.id} style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: 2,
              color: darkMode ? '#ccc' : '#666'
            }}>
              <div
                style={{
                  width: 12,
                  height: 12,
                  borderRadius: '50%',
                  backgroundColor: segment.color,
                  marginRight: 6
                }}
              ></div>
              {segment.name}
            </div>
          ))}
        </div>
      </div>
    </Space>
  );
};

export default TechnicalFilters;
